import React from "react";
import moment from "moment";

class DateFormat extends React.Component {
  constructor(props) {
    super(props);
  }



  render() {
    const DBDATE = this.props?.value === "" || this.props.value?.includes("1899") || this.props.value === null  ? "" : moment(this.props?.value).format('DD/MM/YYYY')
    return (
         DBDATE
    )
  }
}
export default DateFormat;
